export const styles = {
    container: {
        position: 'fixed',
        top: 0,
        left: 0,
        width: '100vw',
        height: '100vh',
        zIndex: 10,
        overflow: 'hidden',
        backgroundColor: '#1A1A1C',

        '& .slick-slider': {
            position: 'relative',
            boxSizing: 'border-box',
            userSelect: 'none',
            height: '100%',
            touchAction: 'pan-y'
        },
        '& .slick-list': {
            position: 'relative',
            height: 'calc(100% - 120px)',
            overflow: 'hidden'
        },
        '& .slick-track': {
            position: 'relative',
            top: 0,
            left: 0,
            height: '100%'
        },
        '& .slick-slide': {
            float: 'left',
            display: 'flex',
            padding: [24, 0],
            height: '100%',
            boxSizing: 'border-box',
            minHeight: '1px',
            flexDirection: 'column',
            justifyContent: 'center'
        },
        '& .slick-slide div': {
            maxHeight: '100%',
            outline: 'none',
            overflow: 'hidden'
        },
        '& .slick-slide img': {
            display: 'block',
            margin: '0 auto',
            maxHeight: '100%',
            maxWidth: '60%'
        },
        '& .slick-dots': {
            position: 'absolute',
            bottom: 16,
            width: '100%'
        },
        '& .slick-dots ul': {
            display: 'flex !important',
            padding: [0, 4],
            margin: 0,
            textAlign: 'center',
            listStyle: 'none'
        },
        '& .slick-dots::-webkit-scrollbar': {
            display: 'none'
        },
        '& .slick-dots li': {
            position: 'relative',
            display: 'inline-block',
            width: 174,
            minWidth: 174,
            height: 97,
            margin: [0, 4],
            padding: 0,
            cursor: 'pointer',
            overflow: 'hidden',
            opacity: 0.5
        },
        '& .slick-active': {
            opacity: '1 !important'
        },
        '& .slick-arrow': {
            position: 'absolute',
            top: '40%',
            zIndex: 1,
            cursor: 'pointer'
        },
        '& .slick-prev': {
            left: 24
        },
        '& .slick-next': {
            right: 24,
            transform: 'rotate(180deg)'
        }
    },
    title: {
        position: 'absolute',
        top: 21,
        left: 24,
        maxWidth: '17%',
        fontSize: 14,
        lineHeight: '20px',
        fontWeight: 'bold',
        whiteSpace: 'nowrap',
        color: '#fff',
        zIndex: 1
    },
    closeButton: {
        position: 'absolute',
        right: 22,
        top: 21,
        padding: 2,
        height: 24,
        width: 24,
        zIndex: 1,
        border: 'none',
        outline: 'none',
        backgroundColor: 'transparent',
        cursor: 'pointer'
    }
};

export type ComponentJSSClasses = typeof styles;
